import styled from "styled-components";
import { variant } from "styled-system";
import { Box } from "./Box";

export const Text = styled(Box)(
  {
    whiteSpace: props => (props.truncate ? "nowrap" : "unset"),
    overflow: props => (props.truncate ? "hidden" : "unset"),
    textOverflow: props => (props.truncate ? "ellipsis" : "unset")
  },
  variant({
    variants: {
      primary: {
        fontSize: ({ fontSizes }) => fontSizes[1],
        color: props => props.colors.grey.colorGrey60,
        fontWeight: 500
      },
      primaryBold: {
        fontSize: ({ fontSizes }) => fontSizes[1],
        color: props => props.colors.grey.colorGrey60,
        fontWeight: "bold"
      },
      secondary: {
        fontSize: ({ fontSizes }) => fontSizes[0],
        color: props => props.colors.grey.colorGrey60,
        fontWeight: 500
      },
      tertiary: {
        fontSize: ({ fontSizes }) => fontSizes[0],
        color: props => props.colors.grey.colorGrey45
      }
    }
  })
);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/Text.js